import commonService from "./common-service";

class DocumentService {
  async uploadDocument(params) {
    try {
      const response = await commonService.postToServer("Documents", params);
      if (response) {
        return response;
      } else {
        throw new Error("Error uploading document");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getDocuments() {
    try {
      const response = await commonService.getFromServer("Documents", {});

      if (response) {
        return response;
      } else {
        throw new Error("Error getting documents");
      }
    } catch (e) {
      throw new Error("Error getting documents");
    }
  }
  async getDocumentUrl(params) {
    try {
      const response = await commonService.postToServer("Upload", params);

      if (response) {
        return response;
      } else {
        throw new Error("Error getting documents");
      }
    } catch (e) {
      throw new Error("Error getting documents");
    }
  }
  async deleteDocument(id) {
    try {
      const response = await commonService.deleteToServer(
        "Documents?id=" + id,
        {}
      );

      if (response) {
        return response;
      } else {
        throw new Error("Error deleting document");
      }
    } catch (e) {
      throw new Error("Error deleting document");
    }
  }
  async downloadDocument(params) {
    try {
      const response = await commonService.getFromServer(
        "Documents/" + params.id,
        {}
      );

      if (response) {
        return response[0];
      } else {
        throw new Error("Error downloading document");
      }
    } catch (e) {
      throw new Error("Error downloading document");
    }
  }
}
export default new DocumentService();
